<ng-template #loading>
   <mat-spinner diameter="40"></mat-spinner>
</ng-template>

<ng-container *ngIf="user else loading">
   <div class="common-flex common-jccenter common-pointer">
      <ngx-avatars [src]="user.avatar" [value]="user.initials || user.email[0]" [round]="true" [size]="size"></ngx-avatars>
   </div>
</ng-container>
